import React from 'react'


const AddChatDialogContext = React.createContext();

export const useAddChatDialog = () => React.useContext(AddChatDialogContext);

export const AddChatDialogProvider = ({ children }) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const value = {
    dialogOpen,
    setDialogOpen,
  };
  return (
    <AddChatDialogContext.Provider value={value}>
      {children}
    </AddChatDialogContext.Provider>
  );
};
